import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

export const getBazaarvoicePageView = (
    data: EnrichedAnalyticsEvent<ProductImpressionTrackingInfo>
) => {
    const eventData = data.payload.eventData;

    if (!eventData.reviewCount) return;

    const pageViewData: BV.PageViewData = {
        bvProduct: "RatingsAndReviews",
        productId: eventData.id,
        type: "Product",
        brand: eventData.brand,
        categoryId: eventData.category,
        numReviews: eventData.reviewCount,
        avgRating: eventData.reviewAverage,
        percentRecommended: eventData.reviewPercentRecommended
    };

    return pageViewData;
};
